// 品牌：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 品牌界面
export const ui = Object.freeze({
  "pcBrand.back": "返回",
  "pcBrand.unknown": "未知",
  "pcBrand.uncategorized": "未分類",
  "pcBrand.claimBrand": "認領品牌",
  "pcBrand.brandManagement": "品牌管理",
  "pcBrand.brandIntroduction": "品牌簡介",
  "pcBrand.noBrandIntroduction": "暫無品牌簡介",
  "pcBrand.companyIntroduction": "企業介紹",
  "pcBrand.noCompanyIntroduction": "暫無企業介紹",
  "pcBrand.openProductData": "進入產品資料",
  "pcBrand.productImage": "產品圖片",
  "pcBrand.sold": "已售：",
  "pcBrand.noProductData": "暫無產品資料",
  "pcBrand.relatedCompanies": "關聯企業",
  "pcBrand.brandOwner": "自有品牌",
  "pcBrand.distributor": "代理商",
  "pcBrand.trader": "貿易商",
  "pcBrand.active": "有效",
  "pcBrand.disabled": "停用",
  "pcBrand.unknownType": "未知類型",
  "pcBrand.visitCompany": "進入公司主頁",
  "pcBrand.noRelatedCompanies": "暫無關聯企業",
  "pcBrand.noRelatedCompaniesOfThisType": "暫無此類關聯企業",
  "pcBrand.relatedProductFamilies": "關聯商品系列",
  "pcBrand.value1Model": "1 個型號",
  "pcBrand.relatedOrders": "關聯訂單",
  "pcBrand.orders": "訂單數",
  "pcBrand.tradedQuantity": "成交數量",
  "pcBrand.tradeValue": "成交金額",
  "pcBrand.tradingRegions": "成交地區",
  "pcBrand.time": "時間",
  "pcBrand.tradedModel": "成交型號",
  "pcBrand.product": "產品",
  "pcBrand.region": "地區",
  "pcBrand.quantity": "數量",
  "pcBrand.transactionValue": "交易額",
  "pcBrand.createdAt": "建立時間",
  "pcBrand.brandStrengths": "品牌優勢",
  "pcBrand.leadingTechnology": "技術領先",
  "pcBrand.industryLeadingRDCapabilitiesAndPatents": "擁有行業領先的研發技術和專利",
  "pcBrand.qualityAssurance": "品質保證",
  "pcBrand.rigorousQualityControlsToEnsureProductQuality":
    "嚴格的品質控制體系，確保產品品質",
  "pcBrand.marketLeadership": "市場領先",
  "pcBrand.aStrongMarketShareInTheIndustry": "在行業內擁有較高的市場佔有率",
  "pcBrand.comprehensiveService": "完善服務",
  "pcBrand.comprehensiveTechnicalSupportAndAfterSalesService": "提供全方位的技術支援和售後服務",
  "pcBrand.companyNews": "公司動態",
  "pcBrand.partners": "合作伙伴",
  "pcBrand.relatedBrands": "相關品牌",
  "pcBrand.more": "更多 ▼",
  "pcBrand.collapse": "收起 ▲",
  "pcBrand.beijing0Shanghai0Guangzhou0Shenzhen0":
    "北京0家 | 上海0家 | 廣州0家 | 深圳0家",
  "pcBrand.applications": "應用領域",
  "pcBrand.trademarkRegistrationCertificates": "商標註冊證書",
  "pcBrand.companyName": "企業名稱",
  "pcBrand.enterCompanyName": "請輸入企業名稱",
  "pcBrand.companyType": "企業類型",
  "pcBrand.trademarkCertificate": "商標證書",
  "pcBrand.distributorAuthorizationCertificate": "代理證書",
  "pcBrand.uploadTrademarkCertificate": "上載商標證書",
  "pcBrand.uploadAuthorizationCertificate": "上載代理證書",
  "pcBrand.cancel": "取消",
  "pcBrand.confirm": "確認",
  "pcBrand.companyNameIsRequired": "企業名稱不可為空",
  "pcBrand.selectCompanyType": "請選擇企業類型",
  "pcBrand.trademarkNumber": "商標編號",
  "pcBrand.headquarters": "總部",
  "pcBrand.productLines": "產品線",
  "pcBrand.authorizedRegions": "授權地區",
  "pcBrand.authorizationPeriod": "授權期限",
  "pcBrand.mainModels": "主營型號",
  "pcBrand.monthlySupplyCapacity": "每月供貨能力",
  "pcBrand.china": "中國",
  "pcBrand.shenzhen": "深圳",
  "pcBrand.eastChina": "華東地區",
  "pcBrand.southChina": "華南地區",
  "pcBrand.shanghaiJiangsuZhejiangAnhui": "上海、江蘇、浙江、安徽",
  "pcBrand.microcontrollersPowerManagementSensorsConnectivityChips":
    "微控制器、電源管理、感應器、連接晶片",
  "pcBrand.value20260101To20261231": "2026-01-01 至 2026-12-31",
  "pcBrand.brandClaimedSuccessfully": "品牌認領成功",
  "pcBrand.brandIdIsRequired": "品牌 ID 不可為空",
  "pcBrand.couldNotLoadBrandDetails": "無法載入品牌詳情",
  "pcBrand.brandInformation": "品牌資料",
  "pcBrand.brandName": "品牌名稱",
  "pcBrand.enterTheChineseBrandName": "請輸入品牌中文名稱",
  "pcBrand.selectBrand": "選擇品牌",
  "pcBrand.englishName": "英文名稱",
  "pcBrand.enterTheEnglishBrandName": "請輸入品牌英文名稱",
  "pcBrand.brandRegion": "品牌地區",
  "pcBrand.selectBrandRegion": "請選擇品牌地區",
  "pcBrand.brandCategory": "品牌分類",
  "pcBrand.selectBrandCategory": "請選擇品牌分類",
  "pcBrand.yearFounded": "成立年份",
  "pcBrand.enterBrandIntroduction": "請輸入品牌簡介",
  "pcBrand.enterCompanyIntroduction": "請輸入企業介紹",
  "pcBrand.smartSecurity": "智能保安",
  "pcBrand.homeAppliances": "家用電器",
  "pcBrand.smartIot": "智能物聯網",
  "pcBrand.medicalElectronics": "醫療電子",
  "pcBrand.communicationsNetworks": "通訊網絡",
  "pcBrand.energyControl": "能源控制",
  "pcBrand.consumerElectronics": "消費電子",
  "pcBrand.industrialControl": "工業控制",
  "pcBrand.automotiveElectronics": "汽車電子",
  "pcBrand.brandLogo": "品牌標誌",
  "pcBrand.uploadLogo": "上載標誌",
  "pcBrand.contactInformation": "聯絡資料",
  "pcBrand.privacyProtection": "私隱保障",
  "pcBrand.contact": "聯絡人",
  "pcBrand.enterContactName": "請輸入聯絡人姓名",
  "pcBrand.contactPhone": "聯絡電話",
  "pcBrand.enterContactPhone": "請輸入聯絡電話",
  "pcBrand.email": "電郵",
  "pcBrand.enterEmailAddress": "請輸入電郵地址",
  "pcBrand.reset": "重設",
  "pcBrand.submitApplication": "提交申請",
  "pcBrand.brandNameIsRequired": "品牌名稱不可為空",
  "pcBrand.brandRegionIsRequired": "品牌地區不可為空",
  "pcBrand.brandCategoryIsRequired": "品牌分類不可為空",
  "pcBrand.yearFoundedIsRequired": "成立年份不可為空",
  "pcBrand.submittedSuccessfully": "提交成功",
  "pcBrand.foundedInYear": "成立於{year}年",
  "pcBrand.productsCount": "產品列表（{count}）",
  "pcBrand.expandCountMore": "展開（{count}項）▼",
  "pcBrand.moreCount": "更多（{count}個）▼",
  "pcBrand.countFamilies": "{count} 個系列",
  "pcBrand.countTrades": "{count} 筆成交",
  "pcBrand.shownTotalCompanies": "{shown} / {total} 家企業",
  "pcBrand.uploadType": "請上載{type}",
  "pcBrand.brandLaunchesNewProducts": "{brand}發佈最新產品",
  "pcBrand.brandLaunchedNewProductsTodayBringingInnovativeSolutionsToTheMarket":
    "{brand}今日發佈最新產品，為市場帶來創新解決方案。",
  "pcBrand.brandAnnouncesStrategicPartnerships": "{brand}宣佈策略合作伙伴關係",
  "pcBrand.brandHasFormedStrategicPartnershipsWithCompaniesToAdvanceTheIndustry":
    "{brand}與多家企業建立策略合作伙伴關係，共同推動行業發展。",
  "pcBrand.brandReportsGrowthIn2025": "{brand}2025年業績增長",
  "pcBrand.brandGrewIn2025AndExpandedItsMarketShare":
    "{brand}2025年業績持續增長，市場佔有率持續擴大。",
  "pcBrand.chinaMasterDistributor": "中國區總代理",
  "pcBrand.eastChinaDistributor": "華東地區代理",
  "pcBrand.southChinaDistributor": "華南地區代理",
  "pcBrand.nationwideTrader": "全國貿易商",
  "pcBrand.regionalTrader": "地區貿易商",
  "pcBrand.authorizedTrader": "授權貿易商",
});

// 页面受控选项与属性显示；原始业务值保持不变。
export const metadataFollowup = Object.freeze({
  "pcBrand.categoryVaristorGdt": "壓敏電阻與氣體放電管",
  "pcBrand.categoryDiodes": "二極管",
  "pcBrand.categoryTransistors": "三極管",
  "pcBrand.categoryResistors": "電阻",
  "pcBrand.categoryCapacitors": "電容",
  "pcBrand.categoryInductors": "電感",
  "pcBrand.regionUnitedKingdom": "英國",
  "pcBrand.regionGermany": "德國",
  "pcBrand.regionFrance": "法國",
  "pcBrand.regionSingapore": "新加坡",
  "pcBrand.regionHongKong": "中國香港",
});

export const messages = Object.freeze({
  ...metadataFollowup, ...ui });

// 已登记品牌显示别名
export const brandNames = Object.freeze({
  镁光: "鎂光",
  美光: "美光",
  三星: "三星",
  现代: "現代",
  英特尔: "英特爾",
  海力士: "海力士",
  金士顿: "金士頓",
  兆易创新: "兆易創新",
  英伟达: "英偉達",
  长江存储: "長江存儲",
  长鑫: "長鑫",
  广达: "廣達",
  摩尔线程: "摩爾線程",
  时创意: "時創意",
  "闪迪/SANDISK": "閃迪/SANDISK",
  南亚: "南亞",
  紫光国芯: "紫光國芯",
  安世: "安世",
  ST意法半导体: "ST意法半導體",
  TI德州仪器: "TI德州儀器",
  "TOSHIBA/东芝": "TOSHIBA/東芝",
  "onsemi/安森美": "onsemi/安森美",
  "Yeestor/得一微": "Yeestor/得一微",
  "AMD/超微": "AMD/超微",
  "OADATA/威刚": "OADATA/威剛",
  "江波龙/FORESEE": "江波龍/FORESEE",
  "高通/GENITOP": "高通/GENITOP",
  "富士通/FUJITSU": "富士通/FUJITSU",
  "芯邦/Chipsbank": "芯邦/Chipsbank",
  "上海贝岭/BL": "上海貝嶺/BL",
  "深圳汉芯/HGC": "深圳漢芯/HGC",
  "宏旺/DICMAX": "宏旺/DICMAX",
  "海天芯/CHTCSEMI": "海天芯/CHTCSEMI",
  "英飞凌/Infineon": "英飛凌/Infineon",
  华虹挚芯: "華虹摯芯",
  "夏普/OSHARP": "夏普/OSHARP",
  "澜智/Zetta": "瀾智/Zetta",
  "华邦/Winbond": "華邦/Winbond",
  "伍尔特/OWurth": "伍爾特/OWurth",
  "恒烁/Zbit": "恒爍/Zbit",
  "芯伯乐/XBLW": "芯伯樂/XBLW",
  "芯天下/XTX": "芯天下/XTX",
  "唯创知音/OWT": "唯創知音/OWT",
  "威世/CVISHAY": "威世/CVISHAY",
  "精工/Seiko": "精工/Seiko",
  "森萨塔/Sensata": "森薩塔/Sensata",
  "上海矽朋/Siproin": "上海矽朋/Siproin",
  "三友/SANYOU": "三友/SANYOU",
  "罗姆/OROHM": "羅姆/OROHM",
  "晶存/Rayson": "晶存/Rayson",
  "瑞萨/RENESAS": "瑞薩/RENESAS",
  "恩智浦/ONXP": "恩智浦/ONXP",
  "迪浦/PUOLOP": "迪浦/PUOLOP",
  "普冉/PUYA": "普冉/PUYA",
  "米客方德/MK": "米客方德/MK",
  "灵星芯微/OLX": "靈星芯微/OLX",
  "来扬/Lyontek": "來揚/Lyontek",
  "力积电子/Zentel": "力積電子/Zentel",
});

// 已登记分类显示别名
export const categoryNames = Object.freeze({
  IC存储器: "IC 儲存器",
  DDR颗粒: "DDR 晶片",
  wafer晶圆: "wafer 晶圓",
  FLASH颗粒: "FLASH 晶片",
  服务器: "伺服器",
  国产服务器: "國產伺服器",
  进口服务器: "進口伺服器",
  电位器: "電位器",
  保险丝: "保險絲",
  服务器条子: "伺服器記憶體模組",
  内存条: "記憶體模組",
  "Nand Flash BGA颗粒": "NAND Flash BGA 晶片",
});

// 已登记地区显示别名
export const regionNames = Object.freeze({
  韩国: "韓國",
  美国: "美國",
  中国: "中國",
  台湾: "台灣",
  欧洲: "歐洲",
  日本: "日本",
});
